import { createIcon } from '@chakra-ui/react';

export const Physics = createIcon({
  displayName: `Physics`,
  viewBox: `0 0 44.087 46.106`,
  path: [
    <defs key="1">
      <clipPath id="a">
        <rect width="44.087" height="46.107" fill="none" />
      </clipPath>
    </defs>,
    <g key="2" clipPath="url(#a)">
      <g transform="translate(-1119.185 576.274)">
        <ellipse
          cx="7.633"
          cy="20.561"
          rx="7.633"
          ry="20.561"
          transform="translate(1129.976 -572.074) rotate(-10.361)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <ellipse
          cx="20.561"
          cy="7.633"
          rx="20.561"
          ry="7.633"
          transform="matrix(0.734, -0.679, 0.679, 0.734, 1120.952, -544.846)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <path
          d="M1153.581-538.961a42.121,42.121,0,0,1-15.169-2.537c-10.751-3.657-18.365-9.858-17.008-13.849s11.174-4.262,21.924-.6,18.365,9.858,17.007,13.849"
          transform="translate(-0.089 -4.904)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <circle
          cx="2.944"
          cy="2.944"
          r="2.944"
          transform="translate(1138.321 -556.408)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
        <path
          d="M1173.113-532.306a2.7,2.7,0,0,1-.482.247,4.181,4.181,0,0,1-.558.175"
          transform="translate(-15.387 -12.796)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
      </g>
    </g>,
  ],
});
